import { useNavigate } from '@tanstack/react-router';
import * as React from 'react';

import { ViewMeta } from 'common/components/cookbook/ViewMeta';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { useSelectedWarehouse } from 'common/hooks/useSelectedWarehouse';

import { addToInventoryRoute } from '..';
import { AddItemToInventory } from './AddItemToInventory';

const maybePreserveSearchQuery =
  (doPreserve?: boolean) => (prev: { searchQuery?: string; searchFromCatalog?: boolean }) =>
    doPreserve
      ? {
          searchQuery: prev.searchQuery,
          // eslint-disable-next-line
          // @ts-ignore
          searchFromCatalog: prev.searchFromCatalog,
        }
      : {};

export const AddToInventoryView: React.FC = () => {
  const selectedWarehouseId = useSelectedWarehouse().id;
  const { itemId: selectedItemId } = addToInventoryRoute.useParams();
  const navigate = useNavigate();
  const f = useFormatMessage();
  const viewTitle = f('receiving.add_to_inventory');

  const handleClose = React.useCallback(
    (preserveSearchQuery?: boolean) => {
      const search = maybePreserveSearchQuery(preserveSearchQuery);
      selectedWarehouseId
        ? void navigate({
            to: '/receiving/warehouse/$warehouseId',
            params: { warehouseId: selectedWarehouseId },
            search,
          })
        : void navigate({
            to: '/receiving',
            search,
          });
    },
    [navigate, selectedWarehouseId],
  );

  return (
    !!selectedWarehouseId && (
      <ViewMeta title={viewTitle}>
        <AddItemToInventory
          selectedItemId={selectedItemId}
          selectedWarehouseId={selectedWarehouseId}
          handleClose={handleClose}
        />
      </ViewMeta>
    )
  );
};
